import url from './URL';

const publicVapidKey =
  "BGceF2R6ZeTl1jOKjJq2jg4j-oRzkNG47cFaxeWflC5xwdqiFeCCfm1nE-L89qJ30cA3t9Lfu6zh9PL_WGnYaRI";
  if ("serviceWorker" in navigator) {
  registerForPushNotifications()
    .catch((err) => alert("Service worker is not working"));
}
// Register SW,Register Push, Send Push
export default async function registerForPushNotifications(sellerId) {
  if (sellerId) {
    // Registering SW
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/worker.js`)
      .then(async (register) => {
        // Registering push
        if (register.active) {
          register.pushManager
            .subscribe({
              userVisibleOnly: true,
              applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
            })
            .then(async (subscription) => {
              // Send Push Notifiactions
              fetch(`${url}/add/notification/token/${sellerId}`, {
                method: "POST",
                body: JSON.stringify({ token: subscription }),
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              })
            });
        }
      });
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
